import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHugoComponent } from './simple-icons-hugo.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHugoComponent ],
    exports:      [ SimpleIconsHugoComponent ],
    bootstrap:    []
})
export class SimpleIconsHugoModule {}
